import { memo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { VStack } from '@library';
import Container from '../../../../core/components/Container';
import SpinnerPage from '../../../../core/components/pages/SpinnerPage';
import PdfViewer from '../../../../core/components/pdf/PdfViewer';
import BreadcrumbsViews from '../../../../core/components/router/BreadcrumbsViews';
import PageNotFound from '../../../../core/components/router/PageNotFound';
import useMetaProduct from '../../../queries/useMetaProduct';
import SparePartsSearchBanner from './SparePartsSearchBanner';
import styles from './SparePartsSearchPdfView.module.scss';

const SparePartsSearchPdfView = () => {
    const [searchParams] = useSearchParams();
    const { product, loading } = useMetaProduct();

    if (loading) {
        return <SpinnerPage />;
    }
    if (!product) {
        return <PageNotFound />;
    }
    return (
        <VStack>
            <div className={styles.header}>
                <Container>
                    <BreadcrumbsViews
                        rootLinks={[
                            {
                                messageId: 'spare parts search',
                                to: '/spare-parts',
                            },
                            {
                                text: `${product.manufacturerName} ${product.model}`,
                                to: `/spare-parts-search?${searchParams.toString()}`,
                            },
                        ]}
                    />
                </Container>
            </div>

            <div className={styles.content}>
                <Container>
                    <VStack gap="small">
                        <SparePartsSearchBanner product={product} searchMode />

                        {product.sparePartDocument && (
                            <PdfViewer
                                className={styles.iframe}
                                src={product.sparePartDocument}
                                title="spare part file"
                            />
                        )}
                    </VStack>
                </Container>
            </div>
        </VStack>
    );
};

export default memo(SparePartsSearchPdfView);
